export let bus = null;

export function Bus(Vue) {
  Vue.prototype.$bus = new Vue();
  bus = Vue.prototype.$bus;
}
